<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 55px; top: 55px">
      <p>Señala el dibujo cuyo nombre no rima.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 95px">
      <p>Escribe las palabras que riman.</p>
    </span>
    <p id="tag01" class="tagDefault textBase basicItem01">CASTILLO</p>
    <p id="tag02" class="tagDefault textBase basicItem01">CAMA</p>
    <p
      id="tag03"
      class="tagDefault textBase basicItem01"
      style="font-size: 27px"
    >
      CALZONCILLO
    </p>

    <p id="tag04" class="tagDefault textBase basicItem01">ORUGA</p>
    <p id="tag05" class="tagDefault textBase basicItem01">RATÓN</p>
    <p id="tag06" class="tagDefault textBase basicItem01">TORTUGA</p>

    <label class="imageRadioButton">
      <input
        type="radio"
        name="part1"
        ref="1-1"
        v-on:change="saveOption('radios', 1, 1)"
        :onload="loadOption('radios', 1, 1)"
      />
      <span
        class="checkmark"
        style="
          margin-left: 50px;
          margin-top: 225px;
          width: 204px;
          height: 170px;
        "
      >
        <img class="image" src="/pages/img/sordocas/assets_p16/castillo.svg" />
      </span>
    </label>
    <label class="imageRadioButton">
      <input
        type="radio"
        name="part1"
        ref="1-2"
        v-on:change="saveOption('radios', 1, 2)"
        :onload="loadOption('radios', 1, 2)"
      />
      <span
        class="checkmark"
        style="
          margin-left: 280px;
          margin-top: 225px;
          width: 204px;
          height: 170px;
        "
      >
        <img class="image" src="/pages/img/sordocas/assets_p16/cama.svg" />
      </span>
    </label>
    <label class="imageRadioButton">
      <input
        type="radio"
        name="part1"
        ref="1-3"
        v-on:change="saveOption('radios', 1, 3)"
        :onload="loadOption('radios', 1, 3)"
      />
      <span
        class="checkmark"
        style="
          margin-left: 510px;
          margin-top: 225px;
          width: 204px;
          height: 170px;
        "
      >
        <img
          class="image"
          src="/pages/img/sordocas/assets_p16/calzoncillo.svg"
        />
      </span>
    </label>

    <label class="imageRadioButton">
      <input
        type="radio"
        name="part2"
        ref="2-1"
        v-on:change="saveOption('radios', 2, 1)"
        :onload="loadOption('radios', 2, 1)"
      />
      <span
        class="checkmark"
        style="
          margin-left: 50px;
          margin-top: 505px;
          width: 204px;
          height: 170px;
        "
      >
        <img
          class="image"
          src="/pages/img/sordocas/assets_p16/hormiguero.svg"
        />
      </span>
    </label>
    <label class="imageRadioButton">
      <input
        type="radio"
        name="part2"
        ref="2-2"
        v-on:change="saveOption('radios', 2, 2)"
        :onload="loadOption('radios', 2, 2)"
      />
      <span
        class="checkmark"
        style="
          margin-left: 280px;
          margin-top: 505px;
          width: 204px;
          height: 170px;
        "
      >
        <img class="image" src="/pages/img/sordocas/assets_p16/cocinero.svg" />
      </span>
    </label>
    <label class="imageRadioButton">
      <input
        type="radio"
        name="part2"
        ref="2-3"
        v-on:change="saveOption('radios', 2, 3)"
        :onload="loadOption('radios', 2, 3)"
      />
      <span
        class="checkmark"
        style="
          margin-left: 510px;
          margin-top: 505px;
          width: 204px;
          height: 170px;
        "
      >
        <img class="image" src="/pages/img/sordocas/assets_p16/pajaro.svg" />
      </span>
    </label>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
      class="pageElement"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="5"
      id="inputField05"
      class="pageElement"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="6"
      id="inputField06"
      class="pageElement"
    />
  </div>
</template>
<style scoped>
#tag01 {
  position: absolute;
  width: 200px;
  left: 770px;
  top: 218px;
}
#tag02 {
  position: absolute;
  width: 200px;
  left: 770px;
  top: 298px;
}
#tag03 {
  position: absolute;
  width: 200px;
  left: 770px;
  top: 378px;
}
#tag04 {
  position: absolute;
  width: 200px;
  left: 770px;
  top: 508px;
}
#tag05 {
  position: absolute;
  width: 200px;
  left: 770px;
  top: 588px;
}
#tag06 {
  position: absolute;
  width: 200px;
  left: 770px;
  top: 668px;
}
#inputField01 {
  position: absolute;
  width: 183px;
  left: 50px;
  top: 404px;
}
#inputField02 {
  position: absolute;
  width: 183px;
  left: 281px;
  top: 404px;
}
#inputField03 {
  position: absolute;
  width: 183px;
  left: 510px;
  top: 404px;
}
#inputField04 {
  position: absolute;
  width: 183px;
  left: 50px;
  top: 684px;
}
#inputField05 {
  position: absolute;
  width: 183px;
  left: 281px;
  top: 684px;
}
#inputField06 {
  position: absolute;
  width: 183px;
  left: 510px;
  top: 684px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 34.mp4",
        "cas/Video 35.mp4",
        "cas/Video 36.mp4",
        "cas/Video 37.mp4",
      ],
    };
  },
  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>